import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M15.579 4.04a4.95 4.95 0 0 0-2.639 1.053c-.11.088-.375.332-.589.542l-.389.381-.371-.375c-.64-.646-1.285-1.06-2.055-1.318a5.03 5.03 0 0 0-3.116.004 4.96 4.96 0 0 0-2.832 2.462c-.397.779-.554 1.446-.553 2.351.001 1.11.263 1.975.877 2.894.258.386.407.543 4.457 4.692 2.425 2.484 3.066 3.119 3.201 3.174.248.1.619.091.842-.02.134-.067.893-.82 2.895-2.872 4.982-5.107 4.62-4.718 4.988-5.348.518-.888.744-1.915.659-3a4.97 4.97 0 0 0-1.373-3.096c-.732-.767-1.717-1.302-2.684-1.46a5.4 5.4 0 0 0-1.318-.064" }, null, -1)
  ]))]))
}
export default { render: render }